import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactApexChart from 'react-apexcharts';
import { Link } from 'react-router-dom';
import {
    IconCircleCheck,
    IconEye,
    IconEyeFilled,
    IconInfoSquareRounded,
    IconMailFilled,
    IconMessageCircle2Filled,
    IconMessageDots,
    IconPhoneFilled,
    IconShare,
    IconThumbUp,
    IconUser,
    IconBookmarkFilled,
    IconSearch,
    IconSun,
    IconPaperclip,
    IconCamera,
    IconHeart,
    IconMessage2,
    IconSunWind,
    IconBrandLinkedin,
    IconBrandInstagram,
    IconBrandTwitter,
    IconSend,
    IconTrash,
} from '@tabler/icons-react';
import {
    avatar1,
    avatar10,
    avatar11,
    avatar12,
    avatar2,
    avatar3,
    avatar7,
    avatar8,
    blogImage1,
    instaImage1,
    instaImage2,
    spaceShip,
    instaImage3,
    instaImage4,
    instaImage5,
    instaImage6,
    instaImage7,
    instaImage8,
    instaImage9,
} from '../../assets/images';
import { VectorMap } from '@react-jvectormap/core';
import { worldMill } from '@react-jvectormap/world';
import { IconDatabase } from '@tabler/icons-react';

export default function Widget() {

    const chartData1 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color1)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 7,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [1, 4, 1, 3, 7, 1],
            }
        ]
    };

    const chartData2 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color5)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 7,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [1, 4, 2, 6, 4, 2],
            }
        ]
    };

    const chartData3 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color3)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 7,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [1, 4, 2, 3, 1, 5],
            }
        ]
    };

    const chartData4 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color4)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 7,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [1, 3, 5, 1, 4, 2],
            }
        ]
    };

    const chartData5 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color4)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 50,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [0, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
            }
        ]
    };

    const chartData6 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color2)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 50,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [40, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
            }
        ]
    };

    const chartData7 = {
        options: {
            stroke: {
                width: 2,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color5)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 50,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [0, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
            }
        ]
    };

    const chartData8 = {
        options: {
            stroke: {
                width: 0,
                curve: 'straight',
            },
            fill: {
                type: "solid",
            },
            colors: ['var(--chart-color1)'],
            dataLabels: {
                enabled: false
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                },
            },
            grid: {
                show: false,
            },
            xaxis: {
                categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: 'var(--danger)',
                        dashArray: 0,
                    },
                }
            },
            yaxis: {
                show: false,
                min: 0,
                max: 50,
                tickAmount: 1,
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 0,
                }
            },
        },
        series: [
            {
                name: "",
                data: [30, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
            }
        ]
    };

    const chartData9 = {
        series: [66],
        options: {
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '70%',
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            offsetY: 8,
                            fontSize: "24px",
                            color: 'var(--chart-color1)',
                            show: true,
                        }
                    },
                },
            },
            fill: {
                colors: ['var(--chart-color1)'],
            },
            stroke: {
                lineCap: "round",
            },
        },
    };

    const chartData10 = {
        series: [26],
        options: {
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '60%',
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            offsetY: 8,
                            fontSize: "24px",
                            color: 'var(--chart-color5)',
                            show: true,
                        }
                    },
                },
            },
            fill: {
                colors: ['var(--chart-color5)'],
            },
            stroke: {
                lineCap: "round",
            },
        },
    };

    const chartData11 = {
        series: [76],
        options: {
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '60%',
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            offsetY: 8,
                            fontSize: "24px",
                            color: 'var(--chart-color2)',
                            show: true,
                        }
                    },
                },
            },
            fill: {
                colors: ['var(--chart-color2)'],
            },
            stroke: {
                lineCap: "round",
            },
        },
    };

    const chartData12 = {
        series: [50],
        options: {
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '60%',
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            offsetY: 8,
                            fontSize: "24px",
                            color: 'var(--chart-color3)',
                            show: true,
                        }
                    },
                },
            },
            fill: {
                colors: ['var(--chart-color3)'],
            },
            stroke: {
                lineCap: "round",
            },
        },
    };

    const chartData13 = {
        series: [
            {
                data: [1212, 5214, 2325, 4235, 2519, 858]
            },
            {
                data: [2541, 2583, 1592, 2674, 2323, 1545]
            },
            {
                data: [2350, 3205, 4520, 2351, 5632, 2020]
            },
        ],
        options: {
            dataLabels: {
                enabled: false
            },
            colors: ['var(--chart-color5)', 'var(--chart-color3)', 'var(--chart-color2)',],
            chart: {
                stacked: true,
                toolbar: {
                    show: false,
                },
            },
            tooltip: {
                x: {
                    show: false,
                },
                style: {
                    fontFamily: 'var(--font-family)',
                },
            },
            xaxis: {
                categories: ["Q1", "Q2", "Q3", "Q4", "Q5", "Q6"],
                labels: {
                    style: {
                        fontFamily: 'var(--font-family)',
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                min: 0,
                max: 12500,
                tickAmount: 5,
                labels: {
                    style: {
                        fontFamily: 'var(--font-family)',
                    },
                }
            },
            plotOptions: {
                bar: {
                    columnWidth: '30%',
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
            }
        },
    };

    const chartData14 = {
        series: [65, 25, 10],
        options: {
            labels: ['Team A', 'Team B', 'Team C'],
            colors: ['var(--chart-color4)', 'var(--chart-color5)', 'var(--chart-color1)'],
            legend: {
                show: false,
            },
        },
    };

    const chatItem = [
        {
            image: avatar1,
            name: "Chris Fox",
            status: false,
            designation: "Designer, Blogger",
        },
        {
            image: avatar2,
            name: "Joge Lucky",
            status: false,
            designation: "Java Developer",
        },
        {
            image: avatar3,
            name: "Isabella",
            status: true,
            designation: "CEO, Lucid",
        },
        {
            image: avatar7,
            name: "Folisise Chosielie",
            status: true,
            designation: "Art director, Movie Cut",
        },
        {
            image: avatar8,
            name: "Alexander",
            status: false,
            designation: "Writter, Mag Editor",
        },
    ]

    const twitterChat = [
        {
            image: avatar1,
            name: "Chris Fox",
            status: true,
            tagline: "Contrary to popular belief not simply text",
            lastSeen: "1 hours ago"
        },
        {
            image: avatar2,
            name: "Joge Lucky",
            status: false,
            tagline: "Contrary to popular belief not simply text",
            lastSeen: "2 hours ago"
        },
        {
            image: avatar3,
            name: "Isabella",
            status: true,
            tagline: "Contrary to popular belief not simply text",
            lastSeen: "1 day ago"
        },
    ]

    const pricingOption2 = [
        {
            image: spaceShip,
            title: "Ultima",
            price: "$349",
            buttonLabel: "Join Now",
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
    ]

    const pricingOption1 = [
        {
            title: "Start",
            price: "$199",
            duration: "per month",
            buttonLabel: "Join Now",
            children: [
                {
                    option: "Responsive Design",
                },
                {
                    option: "Color Customization",
                },
                {
                    option: "HTML5 & CSS3",
                },
                {
                    option: "Styled Elements",
                },
            ],
        },
    ]

    const blogList = [
        {
            image: blogImage1,
            title: "All photographs are accurate",
            content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal",
            buttonTitle: "Continue Reading",
            url: "/blog-detail",
            category: "General",
            like: "28",
            comment: "128",
        },
    ]

    const instaPost = [
        {
            image: instaImage1,
        },
        {
            image: instaImage2,
        },
        {
            image: instaImage3,
        },
        {
            image: instaImage4,
        },
        {
            image: instaImage5,
        },
        {
            image: instaImage6,
        },
        {
            image: instaImage7,
        },
        {
            image: instaImage8,
        },
        {
            image: instaImage9,
        },
    ]

    const categoryItem = [
        {
            title: "eCommerce",
        },
        {
            title: "Microsoft Technologies",
        },
        {
            title: "Creative UX",
        },
        {
            title: "HTML5",
        },
        {
            title: "Wordpress",
        },
        {
            title: "Angular JS",
        },
        {
            title: "Enterprise Mobility",
        },
        {
            title: "Website Design",
        },
        {
            title: "Infographics",
        },
        {
            title: "Wordpress Development",
        },
        {
            title: "Wordpress Development",
        },
        {
            title: "Creative UX",
        },
        {
            title: "HTML5",
        },
    ]

    return (
        <>
            <Breadcrumb title="Widget" path="Widget" />
            <div className='grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                <div className='bg-sky rounded-lg shadow-light md:p-20 p-15 text-white'>
                    <div className='p-15 text-center'>
                        <div className='text-[28px]/[33.6px] font-medium mb-2'>
                            521
                        </div>
                        <div>
                            New items
                        </div>
                    </div>
                </div>
                <div className='bg-black-100 rounded-lg shadow-light md:p-20 p-15 text-white'>
                    <div className='p-15 text-center'>
                        <div className='text-[28px]/[33.6px] font-medium mb-2'>
                            902
                        </div>
                        <div>
                            Uploads
                        </div>
                    </div>
                </div>
                <div className='bg-yellow rounded-lg shadow-light md:p-20 p-15 text-white'>
                    <div className='p-15 text-center'>
                        <div className='text-[28px]/[33.6px] font-medium mb-2'>
                            1,025
                        </div>
                        <div>
                            Feeds
                        </div>
                    </div>
                </div>
                <div className='bg-danger rounded-lg shadow-light md:p-20 p-15 text-white'>
                    <div className='p-15 text-center'>
                        <div className='text-[28px]/[33.6px] font-medium mb-2'>
                            318
                        </div>
                        <div>
                            Comments
                        </div>
                    </div>
                </div>
            </div>
            <div className='grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                <div className='bg-bg-dark rounded-lg shadow-light overflow-hidden'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 uppercase'>
                            EARNINGS
                        </div>
                        <div className='text-[22px]/[28px] font-semibold mb-5'>
                            $22,500
                        </div>
                        <small className='text-text-secondary'>
                            19% compared to last week
                        </small>
                    </div>
                    <ReactApexChart options={chartData1.options} series={chartData1.series} type="area" height={60} width="100%" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light overflow-hidden'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 uppercase'>
                            SALES
                        </div>
                        <div className='text-[22px]/[28px] font-semibold mb-5'>
                            $500
                        </div>
                        <small className='text-text-secondary'>
                            19% compared to last week
                        </small>
                    </div>
                    <ReactApexChart options={chartData2.options} series={chartData2.series} type="area" height={60} width="100%" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light overflow-hidden'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 uppercase'>
                            VISITS
                        </div>
                        <div className='text-[22px]/[28px] font-semibold mb-5'>
                            $21,215
                        </div>
                        <small className='text-text-secondary'>
                            19% compared to last week
                        </small>
                    </div>
                    <ReactApexChart options={chartData3.options} series={chartData3.series} type="area" height={60} width="100%" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light overflow-hidden'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 uppercase'>
                            LIKES
                        </div>
                        <div className='text-[22px]/[28px] font-semibold mb-5'>
                            $421,215
                        </div>
                        <small className='text-text-secondary'>
                            19% compared to last week
                        </small>
                    </div>
                    <ReactApexChart options={chartData4.options} series={chartData4.series} type="area" height={60} width="100%" />
                </div>
            </div>
            <div className='grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
                            <IconThumbUp className='w-[20px] h-[20px] stroke-[1.5]' />
                            Likes
                        </div>
                        <div className=''>
                            22,500
                        </div>
                    </div>
                    <ReactApexChart options={chartData5.options} series={chartData5.series} type="area" height={60} width="100%" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
                            <IconMessageDots className='w-[20px] h-[20px] stroke-[1.5]' />
                            Comments
                        </div>
                        <div className=''>
                            500
                        </div>
                    </div>
                    <ReactApexChart options={chartData6.options} series={chartData6.series} type="bar" height={60} width="100%" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
                            <IconShare className='w-[20px] h-[20px] stroke-[1.5]' />
                            Share
                        </div>
                        <div className=''>
                            2,215
                        </div>
                    </div>
                    <ReactApexChart options={chartData7.options} series={chartData7.series} type="line" height={60} width="100%" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='md:p-20 p-15'>
                        <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
                            <IconEye className='w-[20px] h-[20px] stroke-[1.5]' />
                            View
                        </div>
                        <div className=''>
                            421,215
                        </div>
                    </div>
                    <ReactApexChart options={chartData8.options} series={chartData8.series} type="bar" height={60} width="100%" />
                </div>
            </div>
            <div className='grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-30 mb-30'>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
                        <p className='mb-2 text-[20px]/[26px] font-medium'>
                            Twitter
                        </p>
                        <small>
                            56% Increase
                        </small>
                    </div>
                    <ReactApexChart options={chartData9.options} series={chartData9.series} type="radialBar" height={190} className="mx-auto" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
                        <p className='mb-2 text-[20px]/[26px] font-medium'>
                            Facebook
                        </p>
                        <small>
                            87% Increase
                        </small>
                    </div>
                    <ReactApexChart options={chartData10.options} series={chartData10.series} type="radialBar" height={200} className="mx-auto" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
                        <p className='mb-2 text-[20px]/[26px] font-medium'>
                            Instagram
                        </p>
                        <small>
                            16% Increase
                        </small>
                    </div>
                    <ReactApexChart options={chartData11.options} series={chartData11.series} type="radialBar" height={200} className="mx-auto" />
                </div>
                <div className='bg-bg-dark rounded-lg shadow-light'>
                    <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
                        <p className='mb-2 text-[20px]/[26px] font-medium'>
                            Google +
                        </p>
                        <small>
                            37% Increase
                        </small>
                    </div>
                    <ReactApexChart options={chartData12.options} series={chartData12.series} type="radialBar" height={200} className="mx-auto" />
                </div>
            </div>
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 mb-30'>
                <div className='text-[16px]/[19.2px] font-medium mb-30'>
                    Product Order List
                </div>
                <div className='overflow-auto'>
                    <table className='w-full min-w-[1023px]'>
                        <thead>
                            <tr>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    Order No
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    Product Name
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    Purchased On
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    Shipping Status
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    Payment Method
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>
                                    Payment Status
                                </th>
                                <th align='left' className='border-t border-b-2 border-border p-3'>

                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    Q01
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Iphone 7
                                </td>
                                <td className='p-3 border-t border-border'>
                                    12 Jan 2018
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Dispatched
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Credit card
                                </td>
                                <td className='p-3 border-t border-border'>
                                    <span className='py-1 px-2 uppercase text-[10.5px]/[12px] text-success border border-current rounded'>
                                        APPROVED
                                    </span>
                                </td>
                                <td align='right' width={200} className='p-3 border-t border-border'>
                                    <div className='inline-flex gap-10'>
                                        <button className='btn btn-success'>
                                            View Order
                                        </button>
                                        <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                                            <IconTrash className='text-white w-[18px] h-[18px]' />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    Q02
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Galaxy S8
                                </td>
                                <td className='p-3 border-t border-border'>
                                    18 Jan 2018
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Dispatched
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Internet banking
                                </td>
                                <td className='p-3 border-t border-border'>
                                    <span className='py-1 px-2 uppercase text-[10.5px]/[12px] text-warning border border-current rounded'>
                                        PENDING
                                    </span>
                                </td>
                                <td align='right' width={200} className='p-3 border-t border-border'>
                                    <div className='inline-flex gap-10'>
                                        <button className='btn btn-success'>
                                            View Order
                                        </button>
                                        <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                                            <IconTrash className='text-white w-[18px] h-[18px]' />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    Q03
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Amazon Echo
                                </td>
                                <td className='p-3 border-t border-border'>
                                    22 Feb 2018
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Dispatched
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Credit card
                                </td>
                                <td className='p-3 border-t border-border'>
                                    <span className='py-1 px-2 uppercase text-[10.5px]/[12px] text-success border border-current rounded'>
                                        APPROVED
                                    </span>
                                </td>
                                <td align='right' width={200} className='p-3 border-t border-border'>
                                    <div className='inline-flex gap-10'>
                                        <button className='btn btn-success'>
                                            View Order
                                        </button>
                                        <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                                            <IconTrash className='text-white w-[18px] h-[18px]' />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    Q04
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Google Pixel
                                </td>
                                <td className='p-3 border-t border-border'>
                                    22 Feb 2018
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Dispatched
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Cash on delivery
                                </td>
                                <td className='p-3 border-t border-border'>
                                    <span className='py-1 px-2 uppercase text-[10.5px]/[12px] text-danger border border-current rounded'>
                                        REJECTED
                                    </span>
                                </td>
                                <td align='right' width={200} className='p-3 border-t border-border'>
                                    <div className='inline-flex gap-10'>
                                        <button className='btn btn-success'>
                                            View Order
                                        </button>
                                        <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                                            <IconTrash className='text-white w-[18px] h-[18px]' />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className='p-3 border-t border-border'>
                                    Q05
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Mac Mini
                                </td>
                                <td className='p-3 border-t border-border'>
                                    8 March 2018
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Dispatched
                                </td>
                                <td className='p-3 border-t border-border'>
                                    Debit card
                                </td>
                                <td className='p-3 border-t border-border'>
                                    <span className='py-1 px-2 uppercase text-[10.5px]/[12px] text-success border border-current rounded'>
                                        APPROVED
                                    </span>
                                </td>
                                <td align='right' width={200} className='p-3 border-t border-border'>
                                    <div className='inline-flex gap-10'>
                                        <button className='btn btn-success'>
                                            View Order
                                        </button>
                                        <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                                            <IconTrash className='text-white w-[18px] h-[18px]' />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='grid lg:grid-cols-3 grid-cols-1 gap-30 mb-30'>
                <div className='flex flex-col gap-30'>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-30'>
                            Feeds
                        </div>
                        <div className='mb-5 flex justify-between gap-15 py-3 px-15 border border-border transition-all duration-300 hover:shadow-md'>
                            <div className='flex gap-15'>
                                <IconThumbUp className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[16px]/[19.2px] font-medium'>
                                        7 New Feedback
                                    </p>
                                    <p className='text-text-secondary text-[13px]'>It will give a smart finishing to your site</p>
                                </div>
                            </div>
                            <p className='text-text-secondary text-[13px]'>Today</p>
                        </div>
                        <div className='mb-5 flex justify-between gap-15 py-3 px-15 border border-border transition-all duration-300 hover:shadow-md'>
                            <div className='flex gap-15'>
                                <IconUser className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[16px]/[19.2px] font-medium'>
                                        New User
                                    </p>
                                    <p className='text-text-secondary text-[13px]'>I feel great! Thanks team</p>
                                </div>
                            </div>
                            <p className='text-text-secondary text-[13px]'>10:45</p>
                        </div>
                        <div className='mb-5 flex justify-between gap-15 py-3 px-15 border border-border transition-all duration-300 hover:shadow-md'>
                            <div className='flex gap-15'>
                                <IconInfoSquareRounded className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[16px]/[19.2px] font-medium text-yellow'>
                                        Server Warning
                                    </p>
                                    <p className='text-text-secondary text-[13px]'>Your connection is not private</p>
                                </div>
                            </div>
                            <p className='text-text-secondary text-[13px]'>10:50</p>
                        </div>
                        <div className='mb-5 flex justify-between gap-15 py-3 px-15 border border-border transition-all duration-300 hover:shadow-md'>
                            <div className='flex gap-15'>
                                <IconCircleCheck className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[16px]/[19.2px] font-medium text-danger'>
                                        Issue Fixed
                                    </p>
                                    <p className='text-text-secondary text-[13px]'>WE have fix all Design bug with Responsive</p>
                                </div>
                            </div>
                            <p className='text-text-secondary text-[13px]'>11:05</p>
                        </div>
                        <div className='flex justify-between gap-15 py-3 px-15 border border-border transition-all duration-300 hover:shadow-md'>
                            <div className='flex gap-15'>
                                <IconThumbUp className='stroke-[1.5]' />
                                <div>
                                    <p className='text-[16px]/[19.2px] font-medium'>
                                        7 New Orders
                                    </p>
                                    <p className='text-text-secondary text-[13px]'>You received a new oder from Tina.</p>
                                </div>
                            </div>
                            <p className='text-text-secondary text-[13px]'>11:35</p>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-30'>
                            Subscribe
                        </div>
                        <div className='flex flex-col gap-15'>
                            <div className='form-group'>
                                <input type='text' id='subscribeName' name='subscribeName' placeholder='Enter Your Name' />
                            </div>
                            <div className='form-group'>
                                <input type='email' id='subscribeEmail' name='subscribeEmail' placeholder='Enter Your Email' />
                            </div>
                            <div>
                                <button className='btn btn-primary'>
                                    Subscribe
                                </button>
                            </div>
                        </div>
                    </div>
                    {pricingOption2.map((item, key) => (
                        <div key={key} className='bg-bg-dark rounded-lg shadow-light lg:p-20 p-15 text-center'>
                            <div className='p-20'>
                                <img src={item.image} alt='pricing' width="180" height="180" className='w-[180px] h-[180px] object-cover rounded-full mx-auto' />
                            </div>
                            <div className="text-[32px]/[48px] font-medium p-20 text-text-secondary">
                                {item.title}
                            </div>
                            {item.children.map((res, key) => (
                                <div key={key} className='text-[14px]/[30px] tracking-[1px]'>
                                    {res.option}
                                </div>
                            ))}
                            <div className={`text-[36px]/[43.2px] font-medium p-20 ${item.popular ? 'text-blue' : ''}`}>
                                {item.price}
                            </div>
                            <div className='pb-20'>
                                <button className={`btn ${item.popular ? 'btn-blue' : 'btn-outline-blue'}`}>
                                    {item.buttonLabel}
                                </button>
                            </div>
                        </div>
                    ))}
                    <div className='bg-bg-dark rounded-lg shadow-light'>
                        <div className='text-[16px]/[19.2px] font-medium md:p-20 p-15'>
                            Top Products
                        </div>
                        <ReactApexChart options={chartData13.options} series={chartData13.series} type="bar" height={300} />
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light overflow-hidden'>
                        <div className='md:p-20 p-15'>
                            <div className='flex items-center gap-5'>
                                City :<span className='text-[24px]/[36px]'>San Francisco</span>
                            </div>
                            <div>
                                DAY - 12:07 PM
                            </div>
                            <div className='flex items-center justify-around gap-15 mt-10'>
                                <div className='sm:text-[73px]/[87.6px] text-[50px]/[60px] font-medium'>
                                    34°
                                </div>
                                <IconSun className='sm:w-[80px] sm:h-[80px] w-[50px] h-[50px]' />
                            </div>
                        </div>
                        <div className='overflow-auto'>
                            <table className='w-full min-w-[250px] table-striped'>
                                <tbody>
                                    <tr>
                                        <td className='p-3 border-t border-border'>
                                            Land area
                                        </td>
                                        <td className='p-3 border-t border-border'>
                                            121.4 km²
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='p-3 border-t border-border'>
                                            Humidity
                                        </td>
                                        <td className='p-3 border-t border-border'>
                                            73%
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='p-3 border-t border-border'>
                                            Pressure
                                        </td>
                                        <td className='p-3 border-t border-border'>
                                            25.56 in
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='p-3 border-t border-border'>
                                            Population
                                        </td>
                                        <td className='p-3 border-t border-border'>
                                            8.65 lakhs
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='p-3 border-t border-border'>
                                            Ceiling
                                        </td>
                                        <td className='p-3 border-t border-border'>
                                            25280 ft
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {blogList.map((item, key) => (
                        <div key={key} className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                            <Link to={item.url} className='flex group overflow-hidden'>
                                <img src={item.image} width="1100" height="600" alt='blog post' className='w-full lg:h-[500px] object-cover transition-all duration-700 group-hover:scale-[1.02] group-hover:grayscale' />
                            </Link>
                            <Link to={item.url} className='uppercase text-[20px]/[22px] font-medium md:mt-30 mt-20 line-clamp-1'>
                                {item.title}
                            </Link>
                            <p className='mt-10 text-[16px]/[26px] text-text-secondary line-clamp-2'>
                                {item.content}
                            </p>
                            <div className='md:mt-30 mt-20 flex items-center justify-between flex-wrap gap-15'>
                                <Link to={item.url} className="btn btn-secondary">
                                    {item.buttonTitle}
                                </Link>
                                <div className='text-text-secondary flex items-center gap-20'>
                                    <span className='uppercase transition-all duration-300 hover:text-primary'>
                                        {item.category}
                                    </span>
                                    <span>|</span>
                                    <button className='flex items-center gap-5 transition-all duration-300 hover:text-primary'>
                                        <IconHeart className='w-[16px] h-[16px] stroke-[1.5]' />
                                        {item.like}
                                    </button>
                                    <span>|</span>
                                    <button className='flex items-center gap-5 transition-all duration-300 hover:text-primary'>
                                        <IconMessage2 className='w-[16px] h-[16px] stroke-[1.5]' />
                                        {item.comment}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='flex flex-col gap-30'>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 sm:p-15'>
                        <div className='flex items-center gap-15 justify-between md:p-20 p-15 border-b border-border last:border-none group'>
                            <div className='flex items-center gap-10'>
                                <IconMailFilled className='text-text-secondary' />
                                <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                                    Inbox
                                </p>
                            </div>
                            <span className='inline-block rounded border border-current text-success py-1 px-2 text-[10.5px]/[12px]'>
                                654
                            </span>
                        </div>
                        <div className='flex items-center gap-15 justify-between md:p-20 p-15 border-b border-border last:border-none group'>
                            <div className='flex items-center gap-10'>
                                <IconEyeFilled className='text-text-secondary' />
                                <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                                    Profile visits
                                </p>
                            </div>
                            <span className='inline-block rounded border border-current text-yellow py-1 px-2 text-[10.5px]/[12px]'>
                                364
                            </span>
                        </div>
                        <div className='flex items-center gap-15 justify-between md:p-20 p-15 border-b border-border last:border-none group'>
                            <div className='flex items-center gap-10'>
                                <IconBookmarkFilled className='text-text-secondary' />
                                <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                                    Bookmarks
                                </p>
                            </div>
                            <span className='inline-block rounded border border-current text-danger py-1 px-2 text-[10.5px]/[12px]'>
                                19
                            </span>
                        </div>
                        <div className='flex items-center gap-15 justify-between md:p-20 p-15 border-b border-border last:border-none group'>
                            <div className='flex items-center gap-10'>
                                <IconPhoneFilled className='text-text-secondary' />
                                <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                                    Call
                                </p>
                            </div>
                            <span className='inline-block rounded border border-current text-blue py-1 px-2 text-[10.5px]/[12px]'>
                                12
                            </span>
                        </div>
                        <div className='flex items-center gap-15 justify-between md:p-20 p-15 border-b border-border last:border-none group'>
                            <div className='flex items-center gap-10'>
                                <IconMessageCircle2Filled className='text-text-secondary' />
                                <p className='text-blue transition-all duration-300 group-hover:text-blue-100'>
                                    Message
                                </p>
                            </div>
                            <span className='inline-block rounded border border-current text-warning py-1 px-2 text-[10.5px]/[12px]'>
                                54
                            </span>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-30'>
                            Twitter Feed
                        </div>
                        <div className='form-group flex mb-20'>
                            <textarea rows={3} placeholder='Enter here for tweet...' />
                        </div>
                        <div className='flex items-center gap-10 pb-20 mb-20 border-b border-border'>
                            <button className='btn btn-blue'>
                                Tweet
                            </button>
                            <button className='text-blue transition-all duration-300 hover:text-blue-100'>
                                13K users active
                            </button>
                        </div>
                        <div className='flex flex-col gap-20'>
                            {twitterChat.map((item, key) => (
                                <div key={key} className='flex items-start justify-between gap-10 group cursor-pointer'>
                                    <div className='flex items-center gap-10'>
                                        <div className='relative'>
                                            <img src={item.image} alt='profile' width="40" height="40" className='min-w-[40px] max-w-[40px] min-h-[40px] max-h-[40px] border-2 border-transparent object-cover rounded-full transition-all duration-300 ease-in-out group-hover:border-primary' />
                                            <span className={`inline-block absolute bottom-0 right-0 w-[11px] h-[11px] rounded-full border-2 border-bg-light ${item.status ? 'bg-warning' : 'bg-success'}`}></span>
                                        </div>
                                        <div className='text-left'>
                                            <p className='text-[15px]/[22.5px]'>
                                                {item.name}
                                            </p>
                                            <p className='text-[13px]/[19.5px] text-text-secondary'>
                                                {item.tagline}
                                            </p>
                                        </div>
                                    </div>
                                    <small className='text-right'>
                                        {item.lastSeen}
                                    </small>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-30'>
                            Referrals
                        </div>
                        <div className='mb-30'>
                            <div className='flex items-center justify-between gap-10 mb-20'>
                                <div className='text-[20px]/[24px] font-medium '>
                                    2301
                                </div>
                                visits from Facebook
                            </div>
                            <div className='progress w-full h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                                <div className={`progress-bar w-[70%] h-full bg-danger`}></div>
                            </div>
                        </div>
                        <div className='mb-30'>
                            <div className='flex items-center justify-between gap-10 mb-20'>
                                <div className='text-[20px]/[24px] font-medium '>
                                    2107
                                </div>
                                visits from Twitter
                            </div>
                            <div className='progress w-full h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                                <div className={`progress-bar w-[90%] h-full bg-yellow`}></div>
                            </div>
                        </div>
                        <div className='mb-30'>
                            <div className='flex items-center justify-between gap-10 mb-20'>
                                <div className='text-[20px]/[24px] font-medium '>
                                    2308
                                </div>
                                visits from Search
                            </div>
                            <div className='progress w-full h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                                <div className={`progress-bar w-[50%] h-full bg-sky`}></div>
                            </div>
                        </div>
                        <div className=''>
                            <div className='flex items-center justify-between gap-10 mb-20'>
                                <div className='text-[20px]/[24px] font-medium '>
                                    1024
                                </div>
                                visits from Affiliates
                            </div>
                            <div className='progress w-full h-5 bg-bg-light-100 rounded-sm overflow-hidden'>
                                <div className={`progress-bar w-[60%] h-full bg-success`}></div>
                            </div>
                        </div>
                    </div>
                    <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
                        <div className='flex items-center justify-between gap-10 mb-2 text-text-primary'>
                            <p className='text-[24px]/[28.8px] font-medium'>
                                1TB
                            </p>
                            <IconDatabase />
                        </div>
                        <p className='flex items-center justify-between gap-10'>
                            Storage
                            <small className="text-text-secondary">
                                of 1Tb
                            </small>
                        </p>
                        <div className='progress-striped h-20 bg-bg-light rounded-sm overflow-hidden'>
                            <div className="progress-bar w-[43%] h-full bg-warning text-[12px]/[20px] text-black font-medium px-5 text-center">43%</div>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                            World Map
                        </p>
                        <div className='sm:h-[300px] h-[150px]'>
                            <VectorMap
                                map={worldMill}
                                backgroundColor='var(--bg-dark)'
                                regionStyle={{
                                    initial: {
                                        fill: "var(--text-secondary)"
                                    },
                                    hover: {
                                        fill: "var(--primary)"
                                    },
                                }}
                                series={{
                                    regions: [{
                                        attribute: 'fill',
                                        values: {
                                            'IN': 'var(--danger)',
                                            'AU': 'var(--success)',
                                            'US': 'var(--sky)',
                                            'GB': 'var(--warning)',
                                            'SA': 'var(--info)',
                                        }
                                    }]
                                }}
                            />
                        </div>
                    </div>
                    <div className='bg-gradient-to-r from-rose-300 to-amber-300 text-black-50 rounded-lg shadow-light md:p-30 p-15'>
                        <div className='flex items-center justify-center gap-10 mb-15'>
                            <div className='text-[30px]/[45px]'>
                                27°C
                            </div>
                            <IconSun className='w-[40px] h-[40px]' />
                        </div>
                        <p className='text-center'>
                            Saturday 12 May
                        </p>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light overflow-hidden'>
                        <div className='md:p-20 p-15 flex items-center justify-center'>
                            <IconSunWind className='sm:w-[80px] sm:h-[80px] w-[50px] h-[50px]' />
                        </div>
                        <div className='flex text-white'>
                            <div className='bg-black-50 flex items-center gap-20 md:py-20 md:px-30 p-15 flex-grow'>
                                <p className='sm:text-[65px]/[1] text-[50px]'>25°</p>
                                <div>
                                    <p>
                                        CLOUDY
                                    </p>
                                    <p>
                                        New York, USA
                                    </p>
                                </div>
                            </div>
                            <div className='bg-sky flex items-center gap-20 md:py-20 md:px-30 p-15'>
                                <p className='sm:text-[28px]/[1] text-[20px]'>1st Jun</p>
                            </div>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 flex items-start gap-15 justify-around'>
                        <div className='flex flex-col items-center'>
                            <IconBrandLinkedin className='w-[40px] h-[40px] text-blue' />
                            <p className='mt-5'>
                                Followers
                            </p>
                            <p>
                                2510
                            </p>
                        </div>
                        <div className='flex flex-col items-center'>
                            <IconBrandInstagram className='w-[40px] h-[40px] text-danger' />
                            <p className='mt-5'>
                                Followers
                            </p>
                            <p>
                                231
                            </p>
                        </div>
                        <div className='flex flex-col items-center'>
                            <IconBrandTwitter className='w-[40px] h-[40px] text-sky' />
                            <p className='mt-5'>
                                Followers
                            </p>
                            <p>
                                231
                            </p>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <p className='text-[16px]/[20px] font-medium mb-5'>
                            Email Newsletter
                        </p>
                        <p className='md:mb-30 mb-20 text-text-secondary'>
                            Get our products/news earlier than others, let’s get in touch.
                        </p>
                        <div className='relative w-full overflow-hidden'>
                            <input type='text' id='chatInput' name='chatInput' placeholder='Enter Email...' className='bg-bg-dark border border-border w-full py-[6px] pl-[12px] pr-60  min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
                            <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-l border-l-border right-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-r-[3px]">
                                <IconSend className="text-text-primary w-[20px] h-[20px] stroke-[1.5]" />
                            </button>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                            Instagram Posts
                        </p>
                        <div className='flex flex-wrap gap-5'>
                            {instaPost.map((item, key) => (
                                <Link key={key} to={item.url} className='flex'>
                                    <img src={item.image} width="90" height="90" alt='insta post' className='w-[90px] h-[90px] object-cover' />
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='flex flex-col gap-30'>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-5'>
                            To Do List
                        </div>
                        <div className='mb-30 text-text-secondary'>
                            This Month task list
                        </div>
                        <ul>
                            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
                                <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                                    <input type='checkbox' defaultChecked />
                                    <span className='checkmark'></span>
                                    <span className='to-do-text'>
                                        Report Panel Usag
                                    </span>
                                </label>
                            </li>
                            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
                                <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                                    <input type='checkbox' />
                                    <span className='checkmark'></span>
                                    <span className='to-do-text'>
                                        Report Panel Usag
                                    </span>
                                </label>
                            </li>
                            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
                                <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                                    <input type='checkbox' />
                                    <span className='checkmark'></span>
                                    <span className='to-do-text'>
                                        New logo design for InfiniO
                                    </span>
                                </label>
                            </li>
                            <li className='pb-15 mb-15 last:pb-0 last:mb-0 border-b border-border last:border-none'>
                                <label className='cus-checkbox to-do text-text-primary flex items-center gap-10'>
                                    <input type='checkbox' />
                                    <span className='checkmark'></span>
                                    <span className='to-do-text'>
                                        Design PSD files for InfiniO
                                    </span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-30'>
                            Followers
                        </div>
                        <div className='relative w-full overflow-hidden mb-20'>
                            <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-r border-r-border left-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-l-[3px]">
                                <IconSearch className="text-text-secondary w-[20px] h-[20px] stroke-[1.5]" />
                            </button>
                            <input type='text' id='search' name='search' placeholder='Search...' className='bg-bg-dark border border-border w-full py-[6px] pr-[12px] pl-60  min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
                        </div>
                        <div className='flex flex-col gap-20'>
                            {chatItem.map((item, key) => (
                                <div key={key} className='flex items-center gap-10 group cursor-pointer'>
                                    <div className='relative'>
                                        <img src={item.image} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border-2 border-transparent object-cover rounded-full transition-all duration-300 ease-in-out group-hover:border-primary' />
                                        <span className={`inline-block absolute bottom-0 right-0 w-[11px] h-[11px] rounded-full border-2 border-bg-light ${item.status ? 'bg-warning' : 'bg-success'}`}></span>
                                    </div>
                                    <div className='text-left'>
                                        <p className='text-[15px]/[22.5px]'>
                                            {item.name}
                                        </p>
                                        <p className='text-[13px]/[19.5px] text-text-secondary'>
                                            {item.designation}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {pricingOption1.map((item, key) => (
                        <div key={key} className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 text-center'>
                            <div className={`text-[32px]/[48px] font-medium p-20 ${item.popular ? 'text-blue' : ''}`}>
                                {item.title}
                            </div>
                            {item.children.map((res, key) => (
                                <div key={key}>
                                    <div className='border-t border-border p-15'>
                                        {res.option}
                                    </div>
                                </div>
                            ))}
                            <div className='border-t border-border py-30 px-15'>
                                <div className={`text-[36px]/[43.2px] font-medium ${item.popular ? 'text-blue' : ''}`}>
                                    {item.price}
                                </div>
                                <div className='text-text-secondary'>
                                    {item.duration}
                                </div>
                            </div>
                            <div className='border-t border-border p-20'>
                                <button className={`btn ${item.popular ? 'btn-blue' : 'btn-outline-secondary'}`}>
                                    {item.buttonLabel}
                                </button>
                            </div>
                        </div>
                    ))}
                    <div className='bg-bg-dark rounded-lg shadow-light'>
                        <p className='text-[16px]/[19.2px] font-medium md:p-20 p-15'>
                            Pie Chart
                        </p>
                        <ReactApexChart options={chartData14.options} series={chartData14.series} type="pie" className="max-w-[350px] pb-10 mx-auto" />
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-30'>
                            New Post
                        </div>
                        <div className='form-group flex mb-20'>
                            <textarea rows={4} placeholder='Please type what you want...' />
                        </div>
                        <div className='flex items-center justify-end gap-10'>
                            <button className='btn btn-yellow'>
                                <IconPaperclip className='w-[20px] h-[20px] stroke-[1.5]' />
                            </button>
                            <button className='btn btn-yellow'>
                                <IconCamera className='w-[20px] h-[20px] stroke-[1.5]' />
                            </button>
                            <button className='btn btn-blue'>
                                Post
                            </button>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <div className='text-[16px]/[19.2px] font-medium mb-30'>
                            Stories
                        </div>
                        <div className='flex flex-col gap-20'>
                            <button className='flex items-center gap-10 group cursor-pointer'>
                                <div className='relative'>
                                    <img src={avatar10} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border-2 object-cover rounded-full border-primary' />
                                </div>
                                <div className='text-left'>
                                    <p className='text-[15px]/[22.5px]'>
                                        Watt Mark
                                    </p>
                                    <p className='text-[13px]/[19.5px] text-text-secondary'>
                                        21 hours ago
                                    </p>
                                </div>
                            </button>
                            <button className='flex items-center gap-10 group cursor-pointer'>
                                <div className='relative'>
                                    <img src={avatar11} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border-2 object-cover rounded-full border-primary' />
                                </div>
                                <div className='text-left'>
                                    <p className='text-[15px]/[22.5px]'>
                                        Jay Morgan
                                    </p>
                                    <p className='text-[13px]/[19.5px] text-text-secondary'>
                                        3 hours ago
                                    </p>
                                </div>
                            </button>
                            <button className='flex items-center gap-10 group cursor-pointer'>
                                <div className='relative'>
                                    <img src={avatar12} alt='profile' width="40" height="40" className='w-[40px] h-[40px] border-2 object-cover rounded-full border-primary' />
                                </div>
                                <div className='text-left'>
                                    <p className='text-[15px]/[22.5px]'>
                                        Genelia Perkins
                                    </p>
                                    <p className='text-[13px]/[19.5px] text-text-secondary'>
                                        3 hours ago
                                    </p>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <p className='text-[16px]/[20px] font-medium mb-5'>
                            Leave a reply
                        </p>
                        <p className='mb-30 text-text-secondary'>
                            Your email address will not be published. Required fields are marked*
                        </p>
                        <div className='flex flex-col gap-20'>
                            <div className='grid md:grid-cols-2 gap-20'>
                                <div className='form-group'>
                                    <input type='text' id='blogCommentName' name='blogCommentName' placeholder='Your Name' />
                                </div>
                                <div className='form-group'>
                                    <input type='email' id='blogCommentEmail' name='blogCommentEmail' placeholder='Email Address' />
                                </div>
                            </div>
                            <div className='form-group flex'>
                                <textarea rows={5} placeholder='Please type what you want...' />
                            </div>
                            <button className="btn btn-primary uppercase">
                                Submit
                            </button>
                        </div>
                    </div>
                    <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                        <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                            Categories Clouds
                        </p>
                        <div className='flex flex-wrap gap-5'>
                            {categoryItem.map((item, key) => (
                                <button key={key} className='btn btn-outline-primary' >
                                    {item.title}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
